import PropTypes from "prop-types";

/**
 * LoadingSpinner
 *
 * Purpose: Indicates loading states.
 * Used by: Pages and data-backed components.
 */
function LoadingSpinner({ size }) {
  const sizes = { sm: "h-4 w-4", md: "h-7 w-7", lg: "h-10 w-10" };
  return (
    <div
      className="flex items-center justify-center py-6"
      role="status"
      aria-label="Loading"
    >
      <div
        className={`${sizes[size]} animate-spin rounded-full border-2 border-border border-t-accent`}
      />
    </div>
  );
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(["sm", "md", "lg"]),
};

LoadingSpinner.defaultProps = {
  size: "md",
};

export default LoadingSpinner;
